/*
  PerfumeSteal — Shella Product Gallery Fullscreen History Guard

  Purpose:
  - Opening the native Shella fullscreen gallery creates one temporary
    browser-history entry.
  - Android/iPhone Back button or back gesture closes only the fullscreen
    gallery and keeps the customer on the product page.
  - Closing with the native X button or Escape consumes the temporary
    history entry without leaving the PDP.
  - Does not replace or modify Shella's native gallery, Slick slider,
    zoom, arrows, swipe, or keyboard controls.
*/

(function () {
  'use strict';

  var INIT_KEY = '__shellaFullscreenHistoryGuardInitialized';
  var BODY_CLASS = 'product-gallery-fullscreen';
  var STATE_KEY = 'shellaProductGalleryFullscreen';

  if (window[INIT_KEY]) return;
  window[INIT_KEY] = true;

  var historyEntryActive = false;
  var closingFromPopstate = false;
  var consumingHistoryEntry = false;
  var wasFullscreenOpen = false;

  function isFullscreenOpen() {
    return document.body.classList.contains(BODY_CLASS);
  }

  function getFullscreenCloseControl() {
    var fullscreen = document.querySelector(
      '[data-js-product-gallery-fullscreen]'
    );

    if (!fullscreen) return null;

    return fullscreen.querySelector(
      '[data-js-product-gallery-control-fullscreen]'
    );
  }

  function pushFullscreenHistoryEntry() {
    if (
      historyEntryActive ||
      !window.history ||
      typeof window.history.pushState !== 'function'
    ) {
      return;
    }

    var currentState =
      window.history.state &&
      typeof window.history.state === 'object'
        ? window.history.state
        : {};

    var nextState = {};

    Object.keys(currentState).forEach(function (key) {
      nextState[key] = currentState[key];
    });

    nextState[STATE_KEY] = true;

    window.history.pushState(
      nextState,
      '',
      window.location.href
    );

    historyEntryActive = true;
  }

  function consumeFullscreenHistoryEntry() {
    if (
      !historyEntryActive ||
      !window.history ||
      typeof window.history.back !== 'function'
    ) {
      return;
    }

    historyEntryActive = false;
    consumingHistoryEntry = true;

    window.history.back();
  }

  function closeNativeFullscreen() {
    var closeControl = getFullscreenCloseControl();

    if (!closeControl) {
      closingFromPopstate = false;
      return;
    }

    closeControl.click();

    /*
      Some Shella builds finish the close transition asynchronously.
      Retry once only when the body class is still present.
    */
    window.setTimeout(function () {
      if (!isFullscreenOpen()) return;

      var retryControl = getFullscreenCloseControl();

      if (retryControl) {
        retryControl.click();
      }
    }, 120);
  }

  function handleFullscreenStateChange() {
    var fullscreenOpen = isFullscreenOpen();

    if (fullscreenOpen && !wasFullscreenOpen) {
      wasFullscreenOpen = true;

      if (!closingFromPopstate) {
        pushFullscreenHistoryEntry();
      }

      return;
    }

    if (!fullscreenOpen && wasFullscreenOpen) {
      wasFullscreenOpen = false;

      /*
        Back button/back gesture already consumed the temporary entry.
        Do not call history.back() a second time.
      */
      if (closingFromPopstate) {
        closingFromPopstate = false;
        historyEntryActive = false;
        return;
      }

      /*
        Native X, Escape, or any Shella close action:
        remove only our temporary fullscreen history entry.
      */
      consumeFullscreenHistoryEntry();
    }
  }

  function init() {
    wasFullscreenOpen = isFullscreenOpen();

    if (wasFullscreenOpen) {
      pushFullscreenHistoryEntry();
    }

    var observer = new MutationObserver(
      handleFullscreenStateChange
    );

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    window.addEventListener('popstate', function () {
      /*
        This popstate was intentionally triggered after the customer
        closed the fullscreen with X or Escape.
      */
      if (consumingHistoryEntry) {
        consumingHistoryEntry = false;
        return;
      }

      /*
        While fullscreen is open, browser Back should close only the
        native Shella fullscreen—not leave the product page.
      */
      if (isFullscreenOpen()) {
        historyEntryActive = false;
        closingFromPopstate = true;
        closeNativeFullscreen();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();